<template>
  <div>

    <div class="mb-12">
      <div
          v-if="currentStep > documentSteps.length"
          class="d-flex justify-space-between align-center mb-3"
      >
        <div class="txt-head black--text">
          โครงการส่งเสริมกิจการอุทยานวิทยาศาสตร์ (นิคมธุรกิจวิทยาศาสตร์ภูมิภาค)
        </div>
        <Button
            theme="8"
        >
          Export PDF
        </Button>
      </div>
        <divcard class="d-flex justify-space-between mb-2" style="gap: 24px">
          <div class="d-flex" style="gap: 24px">
            <div>
              <v-img
                  :src="require('../../assets/mhesr.png')"
                  min-width="100"
                  max-width="100"
                  aspect-ratio="1"
              ></v-img>
            </div>

            <div>
              <div class="page-title">สำนักงานปลัดกระทรวงอุดมศึกษาฯ (สป.อว.)</div>
              <div class="d-flex align-center" style="gap: 18px">
                <Iconify
                    class="left-side d-flex justify-end"
                    size="15px"
                    icon="jam:clock"
                ></Iconify>
                <span>{{ toDateRangeFormat(masterData.project_accept_round?.start_date, masterData.project_accept_round?.end_date) }}</span>
              </div>

              <div class="d-flex align-center" style="gap: 18px">
                <Iconify
                    class="left-side d-flex justify-end"
                    size="15px"
                    icon="jam:clock"
                    color="var(--theme-color-three)"
                ></Iconify>
                <span>หน่วยงานรับรองจนถึงวันที่ {{ toDateFormat(masterData.project_accept_round?.consider_date) }}</span>
              </div>
            </div>
          </div>

          <div class="budget-tag">
            <div>ปี งปม.</div>
            <div>{{ masterData.project_accept_round?.plan?.main_project?.fiscal_year }}</div>
          </div>
        </divcard>

        <StatusStep
            v-if="currentStep <= documentSteps.length || !$route.query.preview"
            :current-step="currentStep"
            :steps="documentSteps"
        ></StatusStep>
    </div>

    <!--  Form switcher  -->
    <div>
      <CFormGeneral v-if="currentStep === 1 && !$route.query.preview" :masterData="masterData" :is-same-id="isSameId()" :key="f1_formKey"></CFormGeneral>
      <CFormProject v-if="currentStep === 2" :masterData="masterData" :is-same-id="isSameId()" :key="f2_formKey"></CFormProject>
      <CFormPlan v-if="currentStep === 3" :masterData="masterData" :is-same-id="isSameId()" :key="f3_formKey"></CFormPlan>
      <CFormOOI v-if="currentStep === 4" :masterData="masterData" :is-same-id="isSameId()" :key="f4_formKey"></CFormOOI>
      <CFormAttachment v-if="currentStep === 5" :masterData="masterData" :is-same-id="isSameId()" :key="f5_formKey"></CFormAttachment>
      <CFormSummary v-if="currentStep === 6" :masterData="masterData" :is-same-id="isSameId()" :key="f6_formKey"></CFormSummary>
    </div>

    <!-- Action buttons -->
    <div class="d-flex justify-space-between">
      <Button theme="2" @onClick="onCancel">ยกเลิก</Button>

      <div class="flex-center" v-if="!$route.query.preview">
        <!-- For Dev -->
        <Button theme="4" min-width="120px" :disabled="isLoading" @onClick="summaryForm">Summary</Button>
        <!-- /*For Dev -->
        <Button theme="3" min-width="120px" :disabled="isLoading" @onClick="backForm">&lt; ย้อนกลับ</Button>
        <Button theme="4" min-width="120px" :disabled="isLoading" @onClick="saveDraft">บันทึกฉบับร่าง</Button>
        <Button theme="3" min-width="120px" :disabled="isLoading" @onClick="nextForm">ถัดไป ></Button>
      </div>
    </div>

  </div>
</template>

<script>
import StatusStep from "../../components/StatusStep"
import Button from "../../components/input/Button"
import { eventBus, toDateFormat, toDateRangeFormat } from "../../plugins/global-funcs"
import CFormGeneral from './C/CFormGeneral'
import CFormProject from './C/CFormProject'
import CFormPlan from "./C/CFormPlan"
import CFormOOI from "./C/CFormOOI"
import CFormAttachment from "./C/CFormAttachment"
import CFormSummary from "./C/CFormSummary"
import { mapState } from "vuex"

export default {
  name: "FormC",
  components: {
    StatusStep,
    Button,
    CFormGeneral,
    CFormProject,
    CFormPlan,
    CFormOOI,
    CFormAttachment,
    CFormSummary
  },
  data () {
    return {
      toDateFormat,
      toDateRangeFormat,
      currentStep: 1,
      documentSteps: [
        {
          no: 1,
          name: 'ข้อมูลทั่วไป'
        },
        {
          no: 2,
          name: 'ข้อมูลโครงการ'
        },
        {
          no: 3,
          name: 'แผนงาน'
        },
        {
          no: 4,
          name: 'OOI'
        },
        {
          no: 5,
          name: 'เอกสารแนบ'
        }
      ],
      formGeneral: {},
      formProject: {},
      formPlan: {},
      formOOI: {},
      formAttachment: {},
      masterData: {},
      updateId: undefined,
      f1_formKey: 0,
      f2_formKey: 0,
      f3_formKey: 0,
      f4_formKey: 0,
      f5_formKey: 0,
      f6_formKey: 0
    }
  },
  async created () {
    if (!this.$route.query.round_id && !this.$route.query.id && !this.$route.query.inception_id) return this.onCancel()
    await this.getMasterData()
    if(this.$route.query.preview) return this.summaryForm()
    this.retrieveForms()
    eventBus.$emit('customBcName', 'แผนงานพัฒนาขีดความสามารถทางเทคโนโลยีและวิจัยของภาคเอกชนในพื้นที่')

    //for dev
    // this.currentStep = 5
  },
  computed: {
    ...mapState({
      isLoading: state => state.General.isLoading,
      userInfo: state => state.Auth.User,
      cFormId: state => state.CForm.id
    }),
    isFinal () {
      return this.$route.query.doc_type && this.$route.query.doc_type === 'progress'
    }
  },
  methods: {
    isSameId () {
      return !!this.$route.query.id && (this.$route.query.id == this.cFormId)
    },
    backForm () {
      if (this.currentStep <= 1) return;
      // don't save when back from summary page
      if (this.currentStep <= this.documentSteps.length) {
        this.saveDraft()
      }
      this.currentStep -= 1
      this.$vuetify.goTo('#app')
    },
    nextForm () {
      if (this.currentStep > this.documentSteps.length) {
        this.saveDraft(true)
        return this.$router.push({ name: 'PlanOfferList' })
        // return this.$router.push({ name: 'FormCPreview' })
      }
      this.saveDraft()
      this.currentStep += 1
      this.$vuetify.goTo('#app')
    },

    // For Dev
    summaryForm() {
      this.currentStep = this.documentSteps.length + 1
      this.$vuetify.goTo('#app')
    },
    async saveDraft (isSubmit = false) {
      this.requestForm(this.currentStep)
      let payload = {
        budget_amount: this.formPlan.budget_amount,
        project_section_general_info: this.formGeneral,
        project_section: {
          ...this.formProject,
          ...this.formOOI,
          kpi_sub_values: undefined,
          s3_p4_final_day: this.formPlan.s3_p4_final_day,
          s3_p4_progress_day: this.formPlan.s3_p4_progress_day,
          s3_p4_progress_pct: this.formPlan.s3_p4_progress_pct
        },
        project_section_plan: {
          ...this.formPlan,
          budget_amount: undefined,
          s3_p4_final_day: undefined,
          s3_p4_progress_day: undefined,
          s3_p4_progress_pct: undefined
        },
        kpi_sub_values: this.formOOI.kpi_sub_values ? this.formOOI.kpi_sub_values : [],
        attachments: this.formAttachment ? this.formAttachment : [],
        doc_type: this.$route.query.doc_type === 'progress' ? 'Progress/Final' : undefined
      }

      //check each this.formAttachment has a File or not
      for(let i = 0; i < payload.attachments.length; i++) {
        if (payload.attachments[i] instanceof File) {
          console.log('has file')
          payload.attachments[i] = await this.uploadFile(payload.attachments[i])
        }
      }

      console.log('original payload: ', payload)

      if (this.$route.query.round_id) {
        payload.project_accept_round_id = this.$route.query.round_id
      }
      let res
      if (this.$route.query.id || this.updateId) {
        // case: update
        console.log('update')
        payload = {
          id: this.$route.query.id || this.updateId,
          payload: {
            ...payload,
            status: isSubmit ? 'Submitted1' : 'Draft',
            id: undefined
          }
        }
        if(this.isFinal)
          payload.payload.status = isSubmit ? 'Submitted' : 'Draft'
        // check inception status
        if (this.masterData.form_c && this.masterData.form_c.status === 'Inception') {
          payload.payload.status = isSubmit ? 'Submitted2' : 'Inception'
        }
        console.log('payload updated: ', payload)
        res = await this.$apiFire('CForm/updateFormC', payload)
        console.log('check res', res)
        this.masterData.FormC = res
        this.masterData.kpi_masters = res.kpi_masters
        this.updateSubFormComponent()
      } else {
        // case: store new , inception id
        console.log('store new')
        payload.status = isSubmit ? 'Submitted1' : 'Draft'
        if(this.isFinal)
          payload.status = isSubmit ? 'Submitted' : 'Draft'
        if (this.$route.query.inception_id) {
          payload.inception_id = this.$route.query.inception_id
        }
        console.log('payload store: ', payload)
        res = await this.$apiFire('CForm/storeFormC', payload)

        if (res) {
          // save id
          this.updateId = res
          this.$store.commit('CForm/setGeneralForm', this.formGeneral)
          window.history.replaceState({} , null, window.location.href + '&id=' + res)
        }
        // update changed data
        this.getMasterData()
      }
      console.log(res)
    },
    requestForm (formStep) {
      switch (formStep) {
        case 1:
          eventBus.$emit('cFormGeneral')
          break

        case 2:
          eventBus.$emit('cFormProject')
          break

        case 3:
          eventBus.$emit('cFormPlan')
          break

        case 4:
          eventBus.$emit('cFormOOI')
          break

        case 5:
          eventBus.$emit('cFormAttachment')
          break

      }
    },
    retrieveForms () {
      console.log('retrieveForms', this.$route.query.id)
      // General form
      eventBus.$on('cFormGeneralSend', (form) => {
        this.formGeneral = form
        // keep in storage
        this.$store.commit('CForm/setGeneralForm', this.formGeneral)
      })

      // Project form
      eventBus.$on('cFormProjectSend', (form) => {
        this.formProject = form
        // keep in storage
        this.$store.commit('CForm/setProjectForm', this.formProject)
      })

      // Plan form
      eventBus.$on('cFormPlanSend', (form) => {
        this.formPlan = form
        // keep in storage
        this.$store.commit('CForm/setPlanForm', this.formPlan)
      })

      // OOI form
      eventBus.$on('cFormOOISend', (form) => {
        this.formOOI = form
        // keep in storage
        this.$store.commit('CForm/setOOIForm', this.formOOI)
      })

      // Attachment form
      eventBus.$on('cFormAttachmentSend', (form) => {
        this.formAttachment = form
        // keep in storage
        this.$store.commit('CForm/setAttachmentForm', this.formAttachment)
      })
    },
    async getMasterData () {
      let res
      if (this.$route.query.inception_id || this.$route.query.id || this.updateId) {
        let id = this.$route.query.inception_id || this.$route.query.id || this.updateId
        // edit (wait for api)
        res = await this.$apiFire('CForm/getEditMasterFormC', id)
        // update component with changing key
        this.updateSubFormComponent()
      } else {
        // create
        res = await this.$apiFire('CForm/getMasterFormC', this.$route.query.round_id)
      }
      console.log('getMasterData',res)
      if (res) {
        this.masterData = res
      } else {
        this.onCancel()
      }
    },
    onCancel () {
      this.$router.push({ name: 'AvailablePlan' })
    },
    updateSubFormComponent () {
      this.f1_formKey += 1
      this.f2_formKey += 1
      this.f3_formKey += 1
      this.f4_formKey += 1
      this.f5_formKey += 1
      this.f6_formKey += 1
    },
    async uploadFile(file){
      let formData = new FormData();
      formData.append('files[]', file);
      let payload = {
        files : formData
      }
      let res = await this.$apiFire('Attachment/uploadFile', formData)
      console.log('res@uploadFile', res)
      if (res.length > 0) {
        console.log('file uploaded', res[0])
        return res[0]
      }
    },
    selectFile(id) {
      // querySelector id file จากนั้นเรียก event click
      document.querySelector("#file" + id).click();
    }
  }
}
</script>

<style scoped lang="scss">

</style>